<template>
  <div>
    <section class="bg-white py-8 border-b-2 border-gray-300">
      <div class="w-full md:w-10/12 mx-auto flex justify-between px-4 md:px-0">
        <div class="flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start">
          <h2 class="font-bold text-2xl">Logging You In</h2>
          <h3 class="text-xl text-gray-600 mr-5 mt-5">Please wait while we log you in.</h3>
        </div>
        <span v-if="isWorking" class="mdi mdi-loading mdi-spin text-5xl text-gray-500"></span>
        <div class="flex items-center" v-if="!isWorking">
          <button
            @click="$authService.logout()"
            class="bg-red-200 hover:bg-red-300 text-red-900 font-semibold py-2 pl-3 pr-4 border border-red-400 rounded hover:shadow inline-flex items-center"
          >
            <svg class="fill-current w-6 h-6 mr-2" viewBox="0 0 24 24">
              <path
                d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
              />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </section>

    <section class="py-8">
      <div class="w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0">
        <div
          v-if="!isWorking"
          class="bg-red-200 border-l-4 border-red-600 rounded pl-4 py-6 text-red-900 flex items-center"
        >
          <svg class="fill-current h-12 w-12 mr-4" viewBox="0 0 24 24">
            <path
              d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
            />
          </svg>
          <div>
            <h2 class="text-2xl font-bold">Oops</h2>
            <h3
              class="text-lg"
            >Sorry, there has been an error logging you in. Please try again later or contact our support team.</h3>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.container {
  margin-top: 2em;
}
</style>

<script>
export default {
  data() {
    return {
      isWorking: true
    };
  },
  mounted() {
    this.$nextTick(async () => {
      this.$authService.setAccessToken();
      this.$authService.setIdToken();
      await this.$store.dispatch("getUserProfile");
      console.log(this.$store.state.loggedInUser);
      if (this.$store.state.loggedInUser != null) {
        if (this.$store.state.loggedInUser.has_completed_setup) {
          // console.log("STRIPE ID: ", this.$store.state.loggedInUser.stripeId);
          this.$router.push("/");
        } else {
          // console.log("NO STRIPE ID");
          this.$router.push("/profilestart");
        }
      } else {
        // console.log("NO USER");
        this.isWorking = false;
      }
    });
  }
};
</script>